module.exports = __webpack_public_path__ + "static/img/logo.2d1b4d2a.png";